import React from 'react'
import '../style/App.css'
import '../style/EasybakeSpectrum.css'
import EasybakeProvider, { EasybakeConsumer } from './EasybakeProvider'
import { goToUrlTarget } from '../lib/easybake'

import Nav from './Nav'
import Main from './Main'

export default function App () {
    function getPage (page) {
        if (page) {
            switch (page) {
            case 'accesstoken':
            case 'helloworld':
            case 'buildsomethingcool':
                return <React.Fragment>
                    <div className="adobe-easybake-app-main">
                        <Main page={page} />
                    </div>
                </React.Fragment>
            case 'awsmp':
            case 'contactsales':
            case 'enterprisesetupmeeting':
            case 'credinfo':
            case 'form':
            case 'signup':
            case 'create':
                goToUrlTarget(encodeURI(`${process.env.REACT_APP_CONFIG_APP_EASYBAKE_URL}`), '_top')
            default:
                return <React.Fragment>
                    <div className="adobe-easybake-app-main">
                        <Nav page={page} />
                        <Main page={page} />
                    </div>
                </React.Fragment>
            }
        }
        return null
    }
    return (
        <div className="adobe-easybake-app">
            <EasybakeProvider>
                <EasybakeConsumer>
                    {({ page }) => getPage(page) }
                </EasybakeConsumer>
            </EasybakeProvider>
        </div>
    )
}
